export const SLICE_CATEGORY_CHANGED = 'SLICE_CATEGORY_CHANGED';
export const SLICE_SUBCATEGORY_CHANGED = 'SLICE_SUBCATEGORY_CHANGED';

export const sliceCategoryChangedCreator = (sliceId, category) => ({
  meta: { sliceId },
  type: SLICE_CATEGORY_CHANGED,
  payload: { category },
});

export const sliceSubCategoryChangedCreator = (sliceId, subcategory) => ({
  meta: { sliceId },
  type: SLICE_SUBCATEGORY_CHANGED,
  payload: { subcategory },
});
